import Cookies from 'js-cookie'
// import store from '@/store'

const TookenKey = 'Admin_Token'

export function getToken () {
  return Cookies.get(TookenKey)
}

export function setToken (token) {
  return Cookies.set(TookenKey, token)
}

export function removeToken () {
  return Cookies.remove(TookenKey)
}
// 设置用户信息
export function setLoginUserInfo (loginInfo) {
  return localStorage.setItem('loginUserInfo', JSON.stringify(loginInfo))
}

// 获取用户信息
export function getUserInfo () {
  return JSON.parse(localStorage.getItem('loginUserInfo'))
}
// 删除用户信息
export function delUserInfo () {
  return localStorage.clear()
}

// 用户权限检测
export function userPermission (permissionInfo) {
  return sessionStorage.setItem('userPermission', JSON.stringify(permissionInfo))
}

// 获取用户权限
export function getUserPermission () {
  return JSON.parse(sessionStorage.getItem('userPermission'))
}

// 删除用户权限
export function delPermissionInfo () {
  return sessionStorage.clear()
}

// 设置用户角色
export function setUserRoles (rolesInfo) {
  return sessionStorage.setItem('userRoles', JSON.stringify(rolesInfo))
}

// 获取用户角色
export function getUserRoles () {
  return JSON.parse(sessionStorage.getItem('userRoles'))
}

// 删除用户角色
export function delUserRoles () {
  return sessionStorage.clear()
}

/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkPermi (value) {
  if (value && value instanceof Array && value.length > 0) {
    // const permissions = store.getters && store.getters.permissions
    const permissions = getUserPermission()
    const permissionDatas = value
    const allPermission = '*:*:*'

    const hasPermission = permissions.some(permission => {
      return allPermission === permission || permissionDatas.includes(permission)
    })

    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error('need roles! Like checkPermi="[\'funciton:user:add\',\'funciton:user:edit\']"')
    return false
  }
}

/**
 * 角色权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkRole (value) {
  if (value && value instanceof Array && value.length > 0) {
    // const roles = store.getters && store.getters.roles
    const roles = getUserRoles()
    const permissionRoles = value
    const superAdmin = 'admin'

    const hasRole = roles.some(role => {
      return superAdmin === role || permissionRoles.includes(role)
    })
    if (!hasRole) {
      return false
    }
    return true
  } else {
    console.error('need roles! Like checkRole="[\'admin\',\'manage\']"')
    return false
  }
}
